const calcDisc = () => {
    let item = document.querySelectorAll('.item'),
        preview = document.querySelectorAll('.product-descr');


    function calcDiscount(discount) {
        discount.innerHTML =Math.abs((+discount.previousElementSibling.children[1].children[0].textContent.slice(0, -3).replace(/\s/g, '') / +discount.previousElementSibling.children[0].children[0].textContent.slice(0, -3).replace(/\s/g, '')) - 1) * 100 + '%'
    }


    item.forEach(i => {
        const discount = i.querySelector('.item__discount');
        if(discount) {
            calcDiscount(discount);
        }
    })
    preview.forEach(i => {
        const disc = i.querySelector('.item__discount');
        if(disc) {
            calcDiscount(disc);
        }
    })
}

export default calcDisc;